import React from "react";
import SportsList from "../../components/sportsList";
import SportsBookWrapper from "../sportsBookWrapper";
import FavoritesGamesList from "../../components/favoritesGamesList/index";

export default function topgamesTemplate () {
    let isAsian = this.props.isAsian,
        { sportAlias, regionId, competitionId } = this.props.routeParams,
        gameType = "topGames";
    return (<div className={`import-view-container ${!isAsian ? "sport-view-wrapper" : "asian-view"}`} onClick={this.handleClick()}>
        <SportsList sportAlias={sportAlias}
                    location={this.props.location}
                    gameType={gameType}
                    isAsian={isAsian}/>
        {
            sportAlias && sportAlias !== "Favorites" && <SportsBookWrapper sportAlias={sportAlias}
                                                                           isAsian={isAsian}
                                                                           regionId={regionId}
                                                                           competitionId={competitionId}
                                                                           gameType={gameType}
                                                                           child={this.props.children}/>
        }
        {
            sportAlias && sportAlias === "Favorites" && <FavoritesGamesList/>
        }
    </div>
    );
};